import React, {useEffect, useState} from 'react';
import { RankingFilters } from '../../components/RankingFilters';
import { ReferralTable } from '../../components/ReferralTable';
import apiClient from "../../apiClient";
import gradient_light from "../../img/gradient_light.jpg";
import {useTranslation} from "react-i18next";

const ReferralList = () => {
  const { t, i18n } = useTranslation();
  const [rankings, setRankings] = useState([]);

  useEffect(() => {
    (async () => {
      // TODO: replace itemID to address
      const { data: rankingListData } = await apiClient.get(
          `social/MyReferralList`
      );
     // console.log(`rankingListData = ${JSON.stringify(rankingListData)}`);
      const {
        rankings
      } = rankingListData;
      setRankings(rankings);
    })();
  }, []);

  return (
    <main>
      <section className='relative py-24'>
        <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
          <img src={gradient_light} alt="gradient" className="h-full w-full" />
        </picture>
        <div className='container'>
          <h1 className='py-16 text-center font-display text-4xl font-medium text-jacarta-700 dark:text-white'>
            {t('listreferral.referral_title')}
          </h1>
          {/*<RankingFilters />*/}
          <div className='scrollbar-custom overflow-x-auto'>
            <ReferralTable
                rankings={rankings}/>
          </div>
        </div>
      </section>
    </main>
  );
};

export { ReferralList };
